const translation = {
  Product: "المنتج",
  "Header.productNav": "منتج LUKKEY",
  Feature: "الميزة",
  "About Us": "من نحن",
  FAQ: "الأسئلة المتكررة",
  "Privacy Policy": "سياسة الخصوصية",
  "Help Center": "مركز المساعدة",
  "Header.infoMenu": "المزيد",
  "Header.appNow": "الحصول على التطبيق",
  "Header.appModal.title": "استخدم تطبيق LUKKEY الآن",
  "Header.appModal.subtitle": "اختر منصتك للحصول على تطبيق LUKKEY الرسمي للجوال.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "ثبّت التطبيق الرسمي على iPhone.",
  "Header.appModal.iosButton": "فتح",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "احصل على تطبيق Android الرسمي عبر Google Play.",
  "Header.appModal.googlePlayButton": "فتح",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "نزّل أحدث ملف APK رسمي مباشرةً.",
  "Header.appModal.androidButton": "تنزيل",
  "Header.appModal.note": "تنزيلات الجوال الرسمية فقط. استخدم الروابط أعلاه للحصول على أحدث إصدار.",
  "Academy": "الأكاديمية",
  "Legal": "معلومات قانونية",
  "AboutUs.title": "حول LUKKEY",
  "AboutUs.lede": "LUKKEY هي علامة سويسرية لمحافظ الأجهزة مكرسة لبناء أعلى معايير الأمان لملكية الأصول الرقمية.",
  "AboutUs.vision.closing": "مفاتيحك. أصولك. مستقبلك.",
  "AboutUs.quote": "تبني LUKKEY طبقة الأمان بين الناس والأصول الرقمية.",
  "AboutUs.block1": "تقع LUKKEY في سويسرا. وتركز الشركة على المحافظ الصلبة المصممة للحفظ الذاتي الآمن.",
  "AboutUs.block2": "تجمع منتجاتها بين العناصر الآمنة والحماية ضد العبث والبنية الكاملة غير المتصلة. والهدف هو إبقاء المفاتيح الخاصة داخل بيئة معزولة.",
  "AboutUs.block3": "تم تصميم النظام من دون Wi‑Fi أو USB أو اعتماد مباشر على الشبكة. ويساعد الوصول بالبصمة وأدوات النسخ الاحتياطي عبر NFC والدعم الواسع للأصول على إبقائه عملياً في الاستخدام اليومي.",
  "AboutUs.block5": "تتبع LUKKEY نهجاً مفتوحاً وقابلاً للتدقيق للبرامج الثابتة والبرمجيات الأساسية. ويجب أن تظل مزاعم الأمان قابلة للفحص والتحقق.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "طلب الدعم",
  "WarrantySupport.intro": "يرجى تعبئة المعلومات أدناه لإرسال طلب دعم.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "ملخص المشكلة",
  "WarrantySupport.form.issueTitle.placeholder": "أدخل ملخصًا قصيرًا",
  "WarrantySupport.form.warrantyType.label": "نوع الطلب",
  "WarrantySupport.form.warrantyType.placeholder": "اختر نوع الطلب",
  "WarrantySupport.form.warrantyType.product": "مشكلة الجهاز",
  "WarrantySupport.form.warrantyType.service": "مشكلة التطبيق/الحساب",
  "WarrantySupport.form.warrantyType.replacement": "أخرى",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "صف المشكلة أو الطلب بالتفصيل",
  "WarrantySupport.form.submit": "إرسال طلب الدعم",
  "WarrantySupport.alert.success": "تم إرسال طلب الدعم بنجاح!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "مركز المساعدة",
  "HelpCenter.intro":
    "مرحبًا بك في مركز مساعدة LUKKEY! إذا كنت جديدًا في عالم العملات الرقمية أو تحتاج إلى مساعدة بشأن محفظتك الباردة، فأنت في المكان الصحيح. يوفر حل المحفظة الباردة لدينا الطريقة الأكثر أمانًا لتخزين وإدارة أصولك الرقمية. ستجد أدناه إجابات لبعض الأسئلة الأكثر شيوعًا ونصائح لاستكشاف الأخطاء وإصلاحها.",
  "HelpCenter.section4.title": "هل تحتاج إلى مزيد من المساعدة؟",
  "HelpCenter.section4.intro":
    "وفّر الوقت ببدء طلب الدعم عبر الإنترنت، وسنربطك بمختص. حرصًا على أمانك، لن يطلب الدعم الرسمي عبارة الاسترداد أو المفتاح الخاص:",
  "HelpCenter.contact.hint": "استخدم الزر لإرسال طلب دعم وسنتواصل معك عبر البريد الإلكتروني.",
  "HelpCenter.cta.warranty": "إرسال طلب دعم",
  brandName: "LUKKEY",
  tagline: "إدارة عملتك الرقمية كما لم يحدث من قبل",
  description:
    "ابدأ رحلتك نحو الحرية المالية مع تطبيقنا. قم بتأمين أصولك باستخدام تكنولوجيا المحفظة الباردة المتقدمة، وقم بإدارة أموالك بذكاء وفعالية أكبر. رفاهك المالي هو أولويتنا.",
  "home.seoTitle": "LUKKEY | محفظة أجهزة سويسرية للحفظ الذاتي الآمن",
  "home.seoDescription": "LUKKEY هي علامة سويسرية لمحافظ الأجهزة تركز على أمان المحافظ الباردة، وحماية المفاتيح الخاصة دون اتصال، والوصول ببصمة الإصبع، والنسخ الاحتياطي عبر NFC من أجل حفظ ذاتي أكثر أمانًا.",
  learnMore: "اعرف المزيد",
  "Lock Your Crypto, Securely": "قفل عملاتك الرقمية بأمان",
  Testimonials: "آراء العملاء",
  Testimonial1:
    "لقد كنت أستخدم هذه المحفظة الباردة لشهور الآن، وأنا معجب بموثوقيتها وميزات الأمان الخاصة بها. أوصي بها بشدة!",
  Testimonial2:
    "تجاوزت هذه المحفظة الباردة توقعاتي! واجهتها السهلة والأمان من الدرجة الأولى تجعلها أداة لا غنى عنها لأي شخص جاد في التعامل مع العملات الرقمية.",
  Testimonial3:
    "لقد جربت العديد من المحافظ الباردة من قبل، ولكن هذه تبرز. تصميمها الأنيق وميزاتها المتقدمة تجعل من إدارة أصولي المشفرة أمرًا سهلاً.",
  "John Doe": "جون دو",
  "Cryptocurrency Enthusiast": "متعصب العملات الرقمية",
  "Jane Smith": "جين سميث",
  "Crypto Security Advocate": "مدافع عن أمان العملات الرقمية",
  "Alex Johnson": "أليكس جونسون",
  "Investment Analyst": "محلل استثماري",
  "Touchscreen Interface": "واجهة شاشة تعمل باللمس",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "اختبر إدارة العملات الرقمية بكل سهولة من خلال واجهتنا التفاعلية التي تعمل باللمس، المصممة للتنقل السريع والسهولة عبر أصولك الرقمية، مما يتيح لك إجراء المعاملات بسرعة وإدارة آمنة في متناول يدك.",
  "Bluetooth Connectivity": "الاتصال عبر البلوتوث",
  "Wireless syncing with your devices for real-time updates.":
    "مزامنة لاسلكية مع أجهزتك للحصول على تحديثات فورية.",
  "Airtag Tracking": "تتبع Airtag",
  "Track your wallet easily with built-in Airtag.":
    "تتبع محفظتك بسهولة باستخدام Airtag المدمج.",
  "Secure Chip Technology": "تقنية الشريحة الآمنة",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "مزود بشريحة أمان متقدمة، مما يضمن حماية قوية لأصولك الرقمية الثمينة ضد الوصول غير المصرح به والتهديدات السيبرانية.",
  "Cross-Platform Support": "دعم عبر الأنظمة الأساسية",
  "Works with various platforms for easy accessibility.":
    "يعمل مع منصات مختلفة للوصول بسهولة.",
  AboutUsDescription1:
    "في LUKKEY، نحن ملتزمون بتقديم حلول عالية الجودة لإدارة أصولك الرقمية بشكل آمن.",
  AboutUsDescription2:
    "مقرنا الرئيسي في زيورخ، سويسرا. مع فريق من المحترفين ذوي الخبرة، نسعى للابتكار والتكيف مع المشهد المتغير باستمرار في سوق العملات الرقمية.",
  BlockchainNetworksSupported: "شبكات Blockchain المدعومة",
  CryptocurrenciesSupported: "دعم أكثر من 6,000 عملة رقمية",
  Years: "سنوات",
  ExpertiseInSecurity: "من الخبرة في الأمن",
  FrequentlyAskedQuestions: "الأسئلة المتكررة",
  WhatIsColdWallet: "ما هو محفظة باردة؟",
  ColdWalletDescription:
    "محفظة باردة هي نوع من محفظات العملات الرقمية التي تخزن أصولك الرقمية دون اتصال بالإنترنت، مما يجعلها أقل عرضة للاختراقات والتهديدات الأخرى عبر الإنترنت. على عكس المحافظ الساخنة، التي تتصل بالإنترنت وتناسب المعاملات المتكررة، تعد المحافظ الباردة الأنسب للتخزين طويل الأجل لأنها توفر أمانًا معززًا.",
  HowToSetUpColdWallet: "كيف إعداد محفظتك الباردة؟",
  ColdWalletSetupDescription:
    "إعداد محفظتك الباردة يتضمن عادةً تهيئة الجهاز على جهاز آمن غير متصل بالإنترنت. ستحتاج إلى إنشاء وتخزين عبارة استرداد بشكل آمن، والتي تعد أساسية للوصول إلى أصولك في حالة فقدان الجهاز أو تعطلها. سيتم توفير تعليمات مفصلة مع الشراء لضمان عملية إعداد سلسة.",
  CryptocurrenciesCompatibleWithColdWallet:
    "ما هي العملات الرقمية المتوافقة مع محفظتك الباردة؟",
  CryptocurrenciesCompatibilityDescription:
    "تدعم محافظنا الباردة مجموعة واسعة من العملات الرقمية، بما في ذلك العملات الرئيسية مثل Bitcoin وEthereum وLitecoin، وكذلك العديد من العملات البديلة. للحصول على قائمة كاملة من العملات المدعومة، يرجى زيارة موقعنا الإلكتروني أو الرجوع إلى الوثائق الخاصة بالمنتج.",
  HowToSecureColdWallet: "كيف أضمن أمان محفظتي الباردة؟",
  ColdWalletSecurityDescription:
    "لتأمين محفظتك الباردة، احتفظ دائمًا بعبارة الاسترداد في مكان آمن خاص، ولا تشاركها مع أي شخص، واعتبر استخدام تدابير أمان إضافية مثل الأقفال البيومترية أو الحاويات الآمنة. يساعد أيضًا تحديث البرنامج الثابت للمحفظة بانتظام من الموقع الرسمي في حماية محفظتك من الثغرات.",
  ColdWalletNotWorking:
    "ماذا أفعل إذا كانت محفظتي الباردة لا تعمل أو إذا واجهت خطأ؟",
  ColdWalletErrorDescription:
    "إذا واجهت أي مشكلة مع محفظتك الباردة، راجع قسم استكشاف الأخطاء وإصلاحها في دليل المستخدم. في حال كان لديك مشكلة أكثر تحديدًا، اتصل بفريق الدعم لدينا من خلال موقعنا الإلكتروني. تأكد من أن لديك معلومات جهازك في متناول اليد لتسريع عملية الدعم.",
  Community: "المجتمع",
  "Join our community on your favorite platform to stay up-to-date, ask questions, and connect with other users.":
    "انضم إلى مجتمعنا على منصتك المفضلة لتبقى على اطلاع، تطرح الأسئلة، وتتصل بمستخدمين آخرين.",
  "Subscribe.title": "احصل على تحديثات المنتج",
  "Subscribe.subtitle":
    "نحن نتابع اتجاهات العملات المشفّرة لأجلك. احصل على تحديثات المنتج، ورؤى السوق، ومزايا حصرية — تُرسل مباشرة إلى صندوق بريدك.",
  "Subscribe.placeholder": "أدخل بريدك الإلكتروني",
  "Subscribe.button": "اشترك للحصول على تحديثات المنتج",
  "Subscribe.input.aria": "حقل إدخال عنوان البريد الإلكتروني",
  "Subscribe.success": "شكرًا لاشتراكك! يرجى التحقق من رسالة التأكيد.",
  "Subscribe.error": "فشل الاشتراك. يرجى المحاولة لاحقًا.",
  "Subscribe.invalid": "يرجى إدخال بريد إلكتروني صالح.",
  "Subscribe.privacy":
    "سيُستخدم بريدك الإلكتروني فقط لإرسال نشرتنا وتحديثاتنا. يمكنك إلغاء الاشتراك في أي وقت عبر الرابط الموجود في الرسالة.",
  "Subscribe.learnMore": "اطّلع على المزيد حول كيفية إدارة بياناتك وحقوقك.",
  "Subscribe.popupCompact.title": "ابقَ على اطلاع",
  "Subscribe.popupCompact.subtitle":
    "تحديثات المنتج ورؤى الأمان. بدون رسائل مزعجة.",
  "Subscribe.popupCompact.button": "اشترك",
  "Subscribe.popupCompact.privacy":
    "للبريد الإلكتروني فقط. يمكنك إلغاء الاشتراك في أي وقت.",
  "SubscribeConfirmed.alt.success": "تم تأكيد الاشتراك",
  "SubscribeConfirmed.alt.failed": "فشل الاشتراك",
  "SubscribeConfirmed.title.success": "تم تأكيد الاشتراك",
  "SubscribeConfirmed.title.failed": "فشل الاشتراك",
  "SubscribeConfirmed.message.success":
    "شكرًا لتأكيد بريدك الإلكتروني. تم تفعيل اشتراكك الآن. تم إرسال رسالة ترحيبية إلى صندوق الوارد لديك.",
  "SubscribeConfirmed.message.failed":
    "رابط التأكيد غير صالح أو منتهي الصلاحية. يرجى العودة إلى الصفحة الرئيسية ومحاولة الاشتراك مرة أخرى.",
  "SubscribeConfirmed.cta.backHome": "العودة إلى الصفحة الرئيسية",
  "SubscribeConfirmed.note.unsubscribe":
    "يمكنك إلغاء الاشتراك في أي وقت عبر الرابط الموجود في رسائلنا.",
  // ===== MarketView i18n =====
  "MarketView.title": "لوحة السوق",
  "MarketView.loading": "جارٍ التحميل...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (تويتر)",
  "MarketView.tabError.failed": "فشل في عرض هذا التبويب",
  "MarketView.unknownError": "خطأ غير معروف",

  // ===== Common i18n =====
  "Common.refresh": "تحديث",
  "Common.toggleSeriesVisibility": "تبديل عرض هذه السلسلة",
  "Common.error": "خطأ",
  "Common.dataUpdateTime": "وقت تحديث البيانات",
  "Common.loading": "جارٍ التحميل...",
  "Common.noDataSource": "لا توجد بيانات (لم يتم توفير مصدر البيانات)",

  // ===== Common ranges =====
  "Common.to": "إلى",
  "Common.clear": "مسح",
  "Common.range.thisMonth": "هذا الشهر",
  "Common.range.lastMonth": "الشهر الماضي",
  "Common.range.last2": "آخر شهرين",
  "Common.range.last3": "آخر 3 أشهر",
  "Common.range.last6": "آخر 6 أشهر",
  "Common.range.thisYear": "هذا العام",
  "Common.range.all": "الكل",
  "Common.range.custom": "مخصص",
  "Common.showFilters": "إظهار المرشّحات",
  "Common.hideFilters": "إخفاء المرشّحات",
  "Common.search": "بحث",
  "Common.priority": "الأولوية",
  "Common.owner": "المسؤول",
  "Common.collaborator": "المتعاون",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "تنزيل backend data/youtube_stats.json",
  "YouTubeTab.downloadJson": "تنزيل youtube_stats.json",
  "YouTubeTab.loading": "جارٍ تحميل مؤشرات YouTube...",
  "YouTubeTab.errorHint":
    "إذا لم يتم إعداد مفتاح API، يرجى ضبط YOUTUBE_API_KEY أو GOOGLE_API_KEY في backend/.env ثم إعادة تشغيل الخلفية.",
  "YouTubeTab.header.totalViews":
    "إجمالي المشاهدات (متعدد القنوات، الوحدة: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "إجمالي المشتركين (متعدد القنوات، الوحدة: 10k)",
  "YouTubeTab.dist.views": "توزيع المشاهدات (10k)",
  "YouTubeTab.dist.subscribers": "توزيع المشتركين (10k)",
  "YouTubeTab.card.location": "الموقع:",
  "YouTubeTab.card.registeredAt": "تاريخ التسجيل:",
  "YouTubeTab.card.currentSubscribers": "المشتركون الحاليون",
  "YouTubeTab.card.currentVideos": "عدد الفيديوهات الحالي",
  "YouTubeTab.card.currentTotalViews": "إجمالي المشاهدات الحالي",
  "YouTubeTab.card.currentTotalComments": "إجمالي التعليقات الحالي",
  "YouTubeTab.chart.totalSubscribers": "إجمالي المشتركين",
  "YouTubeTab.chart.totalViews": "إجمالي المشاهدات",
  "YouTubeTab.chart.totalComments": "إجمالي التعليقات",
  "YouTubeTab.chart.totalVideos": "إجمالي الفيديوهات",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "تنزيل backend data/x_stats.json",
  "XTab.downloadJson": "تنزيل x_stats.json",
  "XTab.loading": "جارٍ تحميل مؤشرات X...",
  "XTab.errorHint":
    "إذا لم يتم إعداد الرمز المميز، يرجى ضبط X_BEARER_TOKEN أو TWITTER_BEARER_TOKEN في backend/.env ثم إعادة تشغيل الخلفية.",
  "XTab.header.totalFollowers": "إجمالي المتابعين (متعدد القنوات، الوحدة: 10k)",
  "XTab.header.totalEngagement":
    "إجمالي التفاعل (آخر 5 منشورات: إعجابات + إعادة نشر + ردود + اقتباسات، الوحدة: 10k)",
  "XTab.dist.followers": "توزيع المتابعين (10k)",
  "XTab.dist.engagement":
    "توزيع التفاعل (آخر 5 منشورات: إعجابات + إعادة نشر + ردود + اقتباسات، الوحدة: 10k)",
  "XTab.card.currentFollowers": "المتابعون الحاليون",
  "XTab.card.currentFollowing": "المتابَعات الحالية",
  "XTab.card.currentTweets": "عدد المنشورات الحالي",
  "XTab.card.recentLikes": "الإعجابات الأخيرة (آخر 5 منشورات)",
  "XTab.card.recentRetweets": "إعادات النشر الأخيرة (آخر 5 منشورات)",
  "XTab.card.recentReplies": "الردود الأخيرة (آخر 5 منشورات)",
  "XTab.card.recentQuotes":
    "المشاهدات الأخيرة (على مستوى المحتوى، آخر 5 منشورات)",
  "XTab.card.listed": "عدد الإدراج في القوائم (على مستوى القناة)",
  "XTab.smallChart.followers": "المتابعون",
  "XTab.smallChart.tweets": "المنشورات",
  "XTab.smallChart.likes": "الإعجابات الأخيرة",
  "XTab.smallChart.retweets": "إعادات النشر الأخيرة",
  "XTab.smallChart.replies": "الردود الأخيرة",
  "XTab.smallChart.quotes": "المشاهدات الأخيرة (على مستوى المحتوى)",
  "XTab.smallChart.following": "المتابَعات",
  "XTab.smallChart.listed": "القوائم",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "التصفية حسب شهر الإنشاء:",
  "Analytics.metric.completionRate": "معدل الإتمام",
  "Analytics.metric.teamVelocity": "سرعة الفريق",
  "Analytics.metric.blockerRatio": "نسبة العوائق",
  "Analytics.metric.workloadBalance": "توازن عبء العمل",
  "Analytics.charts.statusDistribution": "توزيع الحالة",
  "Analytics.charts.statusByMonthPercent": "الحالة حسب الشهر (بالنسبة المئوية)",
  "Analytics.charts.priorityDistribution": "توزيع الأولوية",
  "Analytics.charts.priorityByMonthPercent":
    "الأولوية حسب الشهر (بالنسبة المئوية)",
  "Analytics.charts.functionTypeDistribution": "توزيع نوع الوظيفة",
  "Analytics.charts.functionTypeByMonthPercent":
    "نوع الوظيفة حسب الشهر (بالنسبة المئوية)",
  "Analytics.blocker.ownerPie": "قضايا محجوبة · توزيع المسؤول (دونات)",
  "Analytics.blocker.ownerByMonth": "قضايا محجوبة · المسؤول حسب الشهر (٪)",
  "Analytics.bug.ownerPie": "قضايا أخطاء · توزيع المسؤول (دونات)",
  "Analytics.bug.ownerByMonth": "قضايا أخطاء · المسؤول حسب الشهر (٪)",
  "Analytics.ownerWorkloadDistribution": "توزيع عبء عمل الفريق",
  "Analytics.mode.priority": "توزيع الأولوية",
  "Analytics.mode.status": "توزيع الحالة",
  "Analytics.mode.type": "توزيع النوع",
  "Analytics.blocker.attentionNeeded": "قضايا تتطلب اهتمامًا فوريًا",
  "Analytics.common.status": "الحالة",
  "Analytics.common.owner": "المسؤول",
  "Analytics.insights.sectionTitle": "رؤى ومقترحات المشروع",
  "Analytics.insights.efficiency.title": "مقترحات تحسين الكفاءة",
  "Analytics.insights.efficiency.completionRate":
    "• معدل الإتمام الحالي {{rate}}%، يرجى متابعة العوائق",
  "Analytics.insights.efficiency.avgVelocity":
    "• متوسط سرعة الفريق {{velocity}} مهمة/شخص",
  "Analytics.insights.efficiency.workloadBalance":
    "• توازن عبء العمل {{balance}}%",
  "Analytics.insights.risk.title": "تحذيرات المخاطر",
  "Analytics.insights.risk.blockerRatio": "• نسبة العوائق {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• نسبة قضايا P0 {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• عالج القضايا ذات الأولوية العالية أولاً",

  // ===== Kanban i18n =====
  "Kanban.title": "عرض كانبان",
  "Kanban.totalIssues": "إجمالي {{count}} قضية",
  "Kanban.searchPlaceholder":
    "ابحث عن العنوان، رقم القضية، المسؤول أو المتعاونين...",
  "Kanban.status.backlog": "قائمة انتظار",
  "Kanban.status.inProgress": "قيد التنفيذ",
  "Kanban.status.blocked": "محجوب / بانتظار التأكيد",
  "Kanban.status.reviewTest": "مراجعة / اختبار",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "قائمة القضايا",
  "List.totalIssues": "إجمالي {{count}} قضية",
  "List.viewDetails": "عرض التفاصيل",
  "List.openInNewWindow": "فتح في نافذة جديدة",
  "List.empty.title": "لا توجد قضايا",
  "List.empty.subtitle": "أنشئ أول قضية لبدء سير عملك",

  // ===== Assets Register i18n =====
  "Assets.title": "سجل الأصول",
  "Assets.totalSets": "إجمالي المجموعات",
  "Assets.table.employee": "الموظف",
  "Assets.table.setCount": "المجموعات",
  "Assets.table.model": "الطراز",
  "Assets.total": "الإجمالي",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "تتبّع قضايا المشروع",
  "LukkeyIssues.goToDemo": "الانتقال إلى صفحة العرض",
  "LukkeyIssues.githubProject": "مشروع GitHub ↗",
  "LukkeyIssues.githubManageIssues": "إدارة القضايا مباشرة على GitHub ↗",
  "LukkeyIssues.financeModel": "نموذج التمويل",
  "LukkeyIssues.productCoreIssues": "قضايا جوهر المنتج",
  "LukkeyIssues.stats.totalIssues": "📊 إجمالي القضايا",
  "LukkeyIssues.stats.completed": "✅ مكتمل",
  "LukkeyIssues.stats.inProgress": "🔄 قيد التنفيذ",
  "LukkeyIssues.stats.pending": "⏳ قيد الانتظار",
  "LukkeyIssues.stats.blocked": "🚫 محجوب",
  "LukkeyIssues.stats.docs": "📚 المستندات Docs",
  "LukkeyIssues.tabs.kanban": "عرض كانبان",
  "LukkeyIssues.tabs.analytics": "التحليلات",
  "LukkeyIssues.tabs.market": "لوحة السوق",
  "LukkeyIssues.tabs.assets": "سجل الأصول",
  "LukkeyIssues.shareToChatGPT": "افتح LUKKEY.json باستخدام ChatGPT", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "سياسة الخصوصية لشركة LUKKEY",
  "PrivacyPolicy.intro.p1":
    "في LUKKEY نؤمن بأن أكثر أشكال الخصوصية أمانًا هي التي تبقى دائمًا في يد المستخدم نفسه.",
  "PrivacyPolicy.intro.p2":
    "ولذلك، سواء كنت تستخدم جهاز المحفظة الباردة LUKKEY أو تطبيق LUKKEY للهواتف المحمولة (التطبيق)، فإننا نلتزم التزامًا صارمًا بمبدأ ثابت لا يتغير:",
  "PrivacyPolicy.intro.p3_strong":
    "ما لم يصرّح المستخدم صراحةً، فإننا لا نجمع أو نخزّن أو نرفع أي معلومات تخص المستخدم.",
  "PrivacyPolicy.intro.p3_tail":
    "جميع البيانات المتعلقة بالاستخدام تُخزَّن محليًا على جهاز المستخدم فقط، ولا تُرسل إلى LUKKEY أو إلى أي خادم مطلقًا.",
  "PrivacyPolicy.intro.p4": "توضح سياسة الخصوصية هذه كيف نلتزم بهذا المبدأ.",

  "PrivacyPolicy.s1.title": "1. نطاق التطبيق",
  "PrivacyPolicy.s1.appliesTo": "تنطبق سياسة الخصوصية هذه على:",
  "PrivacyPolicy.s1.item.hardware":
    "جهاز المحفظة الباردة (الهاردوير) من LUKKEY",
  "PrivacyPolicy.s1.item.app": "تطبيق LUKKEY للهواتف المحمولة (التطبيق)",
  "PrivacyPolicy.s1.principle":
    "كلاهما يتبع مبدأ الخصوصية الموحّد: «صفر جمع، صفر رفع، تخزين محلي فقط».",

  "PrivacyPolicy.s2.title": "2. المعلومات التي لا نجمعها",
  "PrivacyPolicy.s2.desc":
    "حمايةً لخصوصيتك، نلتزم صراحةً بعدم جمع أو رفع أو تخزين أي معلومات تخص المستخدم، بما في ذلك على سبيل المثال لا الحصر:",
  "PrivacyPolicy.s2.li.identity":
    "معلومات الهوية: الاسم، رقم الهاتف، عنوان البريد الإلكتروني، العنوان البريدي",
  "PrivacyPolicy.s2.li.walletSensitive":
    "بيانات المحفظة الحساسة: المفاتيح الخاصة، العبارات السرية (Mnemonic)، ملفات keystore، كلمات مرور المحفظة",
  "PrivacyPolicy.s2.li.blockchain":
    "بيانات البلوكشين: عناوين المحافظ، سجل المعاملات، معلومات الأصول",
  "PrivacyPolicy.s2.li.behavior":
    "سلوك الاستخدام: سجلات التطبيق، سجلات النقرات، تحليلات السلوك",
  "PrivacyPolicy.s2.li.technical":
    "المعلومات التقنية: معرّفات الجهاز، الموقع الجغرافي، عنوان IP",
  "PrivacyPolicy.s2.inShort.title": "باختصار:",
  "PrivacyPolicy.s2.inShort.desc":
    "كل ما تراه على الجهاز المادي وفي التطبيق موجود فقط على جهازك. لا يمكن لـ LUKKEY الوصول إليه.",

  "PrivacyPolicy.s3.title":
    "3. تصميم الخصوصية والأمان في المحفظة الباردة (الهاردوير)",
  "PrivacyPolicy.s3.desc":
    "توفّر المحفظة الباردة من LUKKEY بيئة آمنة بالكامل دون اتصال بالإنترنت. الميزات الرئيسية:",
  "PrivacyPolicy.s3.h1.title": "1. عتاد أمني بمستوى عسكري",
  "PrivacyPolicy.s3.h1.l1": "Secure Element حاصل على شهادة EAL6+",
  "PrivacyPolicy.s3.h1.l2": "اتصالات مشفّرة بالكامل على مستوى العتاد",
  "PrivacyPolicy.s3.h2.title": "2. وظائف الأمان",
  "PrivacyPolicy.s3.h2.l1": "مصادقة ببصمة الإصبع",
  "PrivacyPolicy.s3.h2.l2": "وضع الخصوصية",
  "PrivacyPolicy.s3.h2.l3": "إدارة معزولة لعدة محافظ",
  "PrivacyPolicy.s3.h3.title": "3. عزل كامل",
  "PrivacyPolicy.s3.h3.l1": "لا اتصال بالإنترنت",
  "PrivacyPolicy.s3.h3.l2": "لا اتصال بسلك بيانات",
  "PrivacyPolicy.s3.h4.title": "4. مقاومة العبث مع خاصية الإتلاف الذاتي",
  "PrivacyPolicy.s3.h4.desc":
    "إذا تعرّض الجهاز للفك أو التلف أو لمحاولة اختراق غير طبيعية، يقوم الـ Secure Element بإتلاف البيانات الحساسة تلقائيًا لمنع استخراج المفاتيح الخاصة.",
  "PrivacyPolicy.s3.h5.title":
    "5. تنفيذ العمليات الحساسة داخل الـ Secure Element فقط",
  "PrivacyPolicy.s3.h5.l1": "إنشاء المحفظة",
  "PrivacyPolicy.s3.h5.l2": "استيراد المحفظة",
  "PrivacyPolicy.s3.h5.l3": "توقيع المعاملات",
  "PrivacyPolicy.s3.h5.note":
    "تتم جميع العمليات الحساسة بنسبة 100٪ داخل الـ Secure Element، ولا تُعرّض لأي شريحة أو مساحة تخزين غير آمنة.",
  "PrivacyPolicy.s3.h6.title":
    "6. لا يتم تخزين بيانات حساسة خارج الـ Secure Element",
  "PrivacyPolicy.s3.h6.desc":
    "لا تخزّن مناطق التخزين غير الآمنة في الجهاز مفاتيح خاصة أو عبارات سرية أو أي معلومات حساسة.",

  "PrivacyPolicy.s4.title": "4. تصميم الخصوصية والأمان في تطبيق LUKKEY",
  "PrivacyPolicy.s4.desc":
    "يركّز تطبيق LUKKEY على عرض المعلومات وتقديم الإشعارات فقط، ولا يتعامل مع بيانات المحفظة الحساسة.",
  "PrivacyPolicy.s4.n1.title": "1. ما الذي لا يفعله التطبيق",
  "PrivacyPolicy.s4.n1.l1": "لا يُنشئ محافظ بلوكشين",
  "PrivacyPolicy.s4.n1.l2": "لا يستورد محافظ بلوكشين",
  "PrivacyPolicy.s4.n1.l3": "لا يخزّن مفاتيح خاصة أو عبارات سرية",
  "PrivacyPolicy.s4.n1.l4": "لا يرفع أي بيانات تخص المستخدم",
  "PrivacyPolicy.s4.n1.l5":
    "لا يجري تحليلات سلوكية أو تتبّعًا إعلانيًا أو جمعًا للبيانات",
  "PrivacyPolicy.s4.n2.title": "2. ما الذي يفعله التطبيق",
  "PrivacyPolicy.s4.n2.l1": "يعرض معلومات متاحة للعامة يتم تفويضها من العتاد",
  "PrivacyPolicy.s4.n2.l2": "يوفّر لوحة إعدادات للخصوصية تشرح غرض كل إذن",
  "PrivacyPolicy.s4.n2.l3":
    "يمنح المستخدم تحكمًا كاملاً لتمكين/تعطيل الأذونات في أي وقت",
  "PrivacyPolicy.s4.n2.l4": "يوفّر حجبًا/إخفاءً للمعلومات الحساسة",
  "PrivacyPolicy.s4.n2.l5": "يعطّل لقطات الشاشة/التسجيل في بعض الشاشات",
  "PrivacyPolicy.s4.n2.l6": "يكتشف عناوين بلوكشين مشبوهة عبر المطابقة المحلية",
  "PrivacyPolicy.s4.n2.l7": "يحدّث بانتظام عناوين URL والعقود والعناوين الخطرة",
  "PrivacyPolicy.s4.n2.l8":
    "تدفّق التحديث أحادي الاتجاه: من الخادم → إلى الجهاز فقط",
  "PrivacyPolicy.s4.n2.l9": "لا يتم إرسال أي بيانات مستخدم أثناء التحديثات",
  "PrivacyPolicy.s4.n3.title": "3. التخزين المحلي",
  "PrivacyPolicy.s4.n3.p1":
    "يخزّن التطبيق محليًا فقط البيانات غير الخاصة مثل تفضيلات الواجهة واللغة ونمط العرض. هذه البيانات:",
  "PrivacyPolicy.s4.n3.l1": "لا تُرفع",
  "PrivacyPolicy.s4.n3.l2": "لا تتم مزامنتها",
  "PrivacyPolicy.s4.n3.l3": "لا يمكن لـ LUKKEY الوصول إليها",

  "PrivacyPolicy.s5.title": "5. نقل البيانات وسياسة الخوادم",
  "PrivacyPolicy.s5.l1": "لا تخزّن خوادم LUKKEY أي معلومات عن المستخدمين",
  "PrivacyPolicy.s5.l2":
    "يقتصر تواصل التطبيق مع الخادم على تحديثات قاعدة البيانات وتحديثات الإصدارات",
  "PrivacyPolicy.s5.l3": "لا يتم نقل أي معلومات عن المستخدم أثناء الاتصال",
  "PrivacyPolicy.s5.l4":
    "حتى في حال اختراق الخادم، فلن تُكشف أي بيانات للمستخدمين لأننا لا نحصل على هذه البيانات أساسًا",

  "PrivacyPolicy.s6.title": "6. الشفافية مفتوحة المصدر",
  "PrivacyPolicy.s6.l1": "شفرة مصدر تطبيق LUKKEY مفتوحة المصدر",
  "PrivacyPolicy.s6.l2":
    "البرمجيات الثابتة المدمجة في عتاد LUKKEY مفتوحة المصدر",
  "PrivacyPolicy.s6.l3": "متاحة بالكامل على GitHub لأي جهة ترغب في المراجعة",
  "PrivacyPolicy.s6.p": "الشفافية جزء من الأمان.",

  "PrivacyPolicy.s7.title": "7. تحكّم كامل للمستخدم",
  "PrivacyPolicy.s7.p":
    "حتى مع عدم جمعنا لمعلومات المستخدمين، يظل للمستخدم السيطرة الكاملة على أجهزته:",
  "PrivacyPolicy.s7.l1": "يمكنك تعطيل أذونات التطبيق في أي وقت",
  "PrivacyPolicy.s7.l2": "يمكنك حذف التطبيق لإزالة جميع بيانات التطبيق المحلية",
  "PrivacyPolicy.s7.l3":
    "يمكنك إعادة ضبط الجهاز المادي لمسح المفاتيح الخاصة وبيانات المحفظة نهائيًا",
  "PrivacyPolicy.s7.p2": "لا تتدخل LUKKEY ولا يمكنها التدخل في هذه الإجراءات.",

  "PrivacyPolicy.s8.title": "8. اتصل بنا",
  "PrivacyPolicy.s8.p":
    "إذا كانت لديك أي أسئلة بخصوص سياسة الخصوصية هذه، يرجى الاتصال بنا:",
  "PrivacyPolicy.s8.email": "البريد الإلكتروني: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "العنوان: المقر الرئيسي لـ LUKKEY، Baarerstrasse 25، 6300 تسوغ، سويسرا",
  "EmailOtp.checking": "جارٍ التحقق...",
  "EmailOtp.title":
    "وصول مقيد: يُرجى إدخال الاسم والبريد الإلكتروني للحصول على رمز التحقق وتسجيل الدخول",
  "EmailOtp.nameLabel": "الاسم",
  "EmailOtp.namePlaceholder": "أدخل اسمك",
  "EmailOtp.emailLabel": "البريد الإلكتروني",
  "EmailOtp.emailPlaceholder": "أدخل بريدك الإلكتروني",
  "EmailOtp.sendCode": "إرسال الرمز",
  "EmailOtp.resendCode": "إعادة إرسال الرمز",
  "EmailOtp.resendWithCountdown": "أعد الإرسال خلال {{s}} ث",
  "EmailOtp.codeValidityHint":
    "رمز التحقق صالح لمدة 5 دقائق. لا تشاركه مع أيّ شخص.",
  "EmailOtp.codeLabel": "رمز التحقق",
  "EmailOtp.codePlaceholder": "أدخل رمز التحقق",
  "EmailOtp.signIn": "تسجيل الدخول",
  "EmailOtp.message.codeSent": "تم إرسال رمز التحقق إلى بريدك الإلكتروني.",
  "EmailOtp.error.nameRequired": "الاسم مطلوب",
  "EmailOtp.error.invalidEmail": "صيغة البريد الإلكتروني غير صحيحة",
  "EmailOtp.error.sendFailed": "فشل إرسال الرمز",
  "EmailOtp.error.codeRequired": "الرجاء إدخال رمز التحقق",
  "EmailOtp.error.verificationFailed": "فشل التحقق من الرمز",
  // ===== Academy i18n =====
  "Academy.hero.alert": "تذكير أمني: تحقق دائمًا من الروابط ولا تشارك عبارة الاسترداد مطلقًا.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "الأكاديمية",
  "Academy.hero.subtitle": "أدلة عملية حول أمان العملات المشفرة، الحفظ الذاتي واستخدام محفظة LUKKEY الباردة.",
  "Academy.search.placeholder": "ابحث عن الدروس، أفضل الممارسات والأسئلة الشائعة…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "مقال",
  "Academy.list.title": "أحدث الأدلة",
  "Academy.list.viewAll": "عرض الكل",
  "Academy.list.empty": "لا توجد نتائج. جرّب كلمة مفتاحية أخرى.",
  "Academy.image.placeholder": "صورة",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "العودة إلى الأكاديمية",
  "AcademyArticle.notFound": "المقال غير موجود",
  "AcademyArticle.author": "المؤلف",
  "AcademyArticle.unscheduled": "لا يوجد وقت نشر مجدول",
  "home.hero.reserveCtaLabel": "وصول مبكر مقابل 1 دولار",
  "home.hero.reserveCtaNote": "قابل للاسترداد بالكامل. بدون التزام بالشراء."
};
export default translation;
